import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';

import { Button, Col, Grid, Layout, Row } from 'antd';
import { RiCloseLine, RiMenuFill } from 'react-icons/ri';
import { Search, Heart } from 'react-iconly';
import { useNavigate } from 'react-router-dom';
import { NAV_DONATE } from '../../../constants';

import HeaderSearch from './HeaderSearch';
import HeaderNotifications from './HeaderNotifications';
import SideDrawer from '../SideDrawer';
import HeaderLogo from '../HeaderLogo';
import HeaderNav from './HeaderNav';

const { Header } = Layout;
const { useBreakpoint } = Grid;

const HeaderHorizontal = props => {
  const { visible, setVisible } = props;
  const screens = useBreakpoint();
  const isMobileSize = screens.xs;
  const navigate = useNavigate();

  const [isSearchHeaderVisible, setIsSearchHeaderVisible] = useState(false);
  const [searchActive, setSearchActive] = useState(false);

  // Mobile Sidebar
  const onClose = () => {
    setVisible(false);
  };

  // Focus
  const inputFocusRef = useRef(null);
  const inputFocusProp = {
    ref: inputFocusRef
  };

  // Search Active
  setTimeout(() => setSearchActive(isSearchHeaderVisible), 100);

  const searchClick = () => {
    setIsSearchHeaderVisible(true);

    setTimeout(() => {
      inputFocusRef?.current?.focus({
        cursor: 'start'
      });
    }, 200);
  };

  // Mobile Sidebar
  const showDrawer = () => {
    setVisible(true);
    setIsSearchHeaderVisible(false);
  };

  // Children
  const renderHeaderChildren = () => {
    return (
      <Row
        wrap={false}
        align="middle"
        justify="space-between"
        gutter={isMobileSize ? 4 : 8}
        className="h-100"
      >
        <Col flex="none">
          <Row align="middle" className="ml-12">
            <Col className="d-flex-center">
              {
                !isMobileSize ? (
                  <HeaderLogo size="full" />
                ) : (
                  <Button
                    type="text"
                    onClick={showDrawer}
                    icon={
                      <RiMenuFill
                        size={24}
                        className="remix-icon text-color-black-80"
                      />
                    }
                  />
                )
              }
            </Col>
          </Row>
        </Col>

        {
          !isSearchHeaderVisible ? (
            <Col flex="auto" className="flex-grow-1 text-center">
              {
                !isMobileSize ? (
                  <HeaderNav />
                ) : (
                  <HeaderLogo size="full" />
                )
              }
            </Col>
          ) : (
            <Col
              flex="auto"
              className={`flex-grow-1 header-search pl-12 ${searchActive && 'header-search-active'}`}
            >
              <HeaderSearch inputFocusProp={inputFocusProp} setSearchHeader={setIsSearchHeaderVisible} />
            </Col>
          )
        }

        <Col flex="none">
          <Row align="middle">
            <Col className="d-flex-center">
              <Button
                className="donate-header-btn"
                shape="round"
                size="small"
                icon={<Heart set="bold" primaryColor="#EA4AAA" size={16} />}
                onClick={() => navigate(NAV_DONATE)}
              >
                Donate
              </Button>
            </Col>

            <Col className="d-flex-center">
              {
                !isSearchHeaderVisible ? (
                  <Button
                    type="text"
                    icon={
                      <Search
                        set="curved"
                        className="text-color-black-60"
                      />
                    }
                    onClick={() => searchClick()}
                  />
                ) : (
                  <Button
                    type="text"
                    icon={
                      <RiCloseLine
                        size={24}
                        className="text-color-black-60"
                      />
                    }
                    onClick={() => setIsSearchHeaderVisible(false)}
                  />
                )
              }
            </Col>

            <HeaderNotifications />
          </Row>
        </Col>
      </Row>
    );
  };

  return (
    <Header className="header-horizontal">
      <Row justify="center" className="w-100">
        <Col xxl={20} xl={22} span={24} className="elevation d-block">
          {renderHeaderChildren()}
        </Col>
      </Row>

      <SideDrawer onClose={onClose} visible={visible} />
    </Header>
  );
};

HeaderHorizontal.propTypes = {
  visible: PropTypes.bool,
  setVisible: PropTypes.func
};

export default HeaderHorizontal;
